module.exports = __webpack_public_path__ + "static/media/57.9e15d55e.png";